export const deutscheMeisterschaft7erRugbyMaenner2026Hannover = {
  "id": "deutsche-meisterschaft-7er-rugby-maenner-2026-hannover",
  "title": "Deutsche Meisterschaft im 7er Rugby: Neun Männerteams kämpfen in Hannover am 23.07. um den Titel",
  "slug": "deutsche-meisterschaft-7er-rugby-maenner-2026-hannover",
  "publishedAt": "2026-07-20T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "7er Rugby",
    "Deutsche Meisterschaft",
    "DIE FINALS",
    "Hannover",
    "Livestream"
  ],
  "excerpt": "Am Donnerstag, 23. Juli 2026, wird in Hannover der Deutsche Meister im 7er Rugby der Männer ermittelt. Im Rahmen der Finals 2026 treten neun Mannschaften in drei Gruppen gegeneinander an. Das Finale beginnt um 17.00 Uhr.",
  "img": "/images/deutsche-meisterschaft-7er-rugby-maenner-2026-hannover.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am Donnerstag, 23. Juli 2026, wird in Hannover der Deutsche Meister im 7er Rugby der Männer ermittelt. Im Rahmen der Finals 2026 treten neun Mannschaften in drei Gruppen gegeneinander an. Das Finale beginnt um 17.00 Uhr."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Neun Mannschaften qualifiziert"
    },
    {
      "type": "paragraph",
      "content": "Über ihre Platzierungen bei der vergangenen Deutschen Meisterschaft qualifizierten sich Vorjahressieger SC Germania List, die RG Heidelberg, Hannover 78, der Berliner SV 1892 und der TSV Handschuhsheim."
    },
    {
      "type": "paragraph",
      "content": "Beim Qualifikationsturnier im Süden sicherten sich der RK Heusenstamm und der München RFC ihre Startplätze. Aus dem Nordturnier lösten der RK 03 Berlin und der SC Frankfurt 1880 ihre Tickets für Hannover."
    },
    {
      "type": "paragraph",
      "content": "Im Anschluss an das Nordturnier wurde Widerspruch gegen die Platzierung des drittplatzierten RC Leipzig eingelegt. Dieser wurde im Rahmen eines Sportgerichtsverfahrens abgewiesen. Am Teilnehmerfeld für die Deutsche Meisterschaft änderte sich damit nichts."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Die Gruppen"
    },
    {
      "type": "paragraph",
      "content": "Die Auslosung erfolgte während der jüngsten RBA Sitzung und ergab folgende Gruppeneinteilung:"
    },
    {
      "type": "list",
      "items": [
        "Gruppe A: Hannover 78, Berliner SV 1892, SC Frankfurt 1880",
        "Gruppe B: München RFC, RG Heidelberg, TSV Handschuhsheim",
        "Gruppe C: RK 03 Berlin, RK Heusenstamm, SC Germania List"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Damit kommt es bereits in der Gruppenphase zu mehreren interessanten Begegnungen. Hannover 78 trifft in Gruppe A auf den Berliner SV 1892 und den SC Frankfurt 1880. In Gruppe B stehen sich mit der RG Heidelberg und dem TSV Handschuhsheim zwei der fünf bestplatzierten Mannschaften des Vorjahres gegenüber. Vorjahressieger SC Germania List bekommt es in Gruppe C mit dem RK 03 Berlin und dem RK Heusenstamm zu tun."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Zwei Spielstätten für die Gruppenphase"
    },
    {
      "type": "paragraph",
      "content": "Die ersten sechs Gruppenspiele des Männerturniers finden auf dem Nebenplatz statt. Gespielt wird auf der Anlage von Hannover 78 am Schnellen Graben."
    },
    {
      "type": "list",
      "items": [
        "08.45 Uhr: Hannover 78 gegen Berliner SV 1892",
        "09.07 Uhr: München RFC gegen RG Heidelberg",
        "09.29 Uhr: RK 03 Berlin gegen RK Heusenstamm",
        "10.57 Uhr: Berliner SV 1892 gegen SC Frankfurt 1880",
        "11.19 Uhr: RG Heidelberg gegen TSV Handschuhsheim",
        "11.41 Uhr: RK Heusenstamm gegen SC Germania List"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Anschließend wechselt das Männerturnier auf den Hauptplatz im Erika Fisch Stadion. Dort werden die verbleibenden drei Gruppenspiele ausgetragen."
    },
    {
      "type": "list",
      "items": [
        "13.09 Uhr: SC Frankfurt 1880 gegen Hannover 78",
        "13.31 Uhr: TSV Handschuhsheim gegen München RFC",
        "13.53 Uhr: SC Germania List gegen RK 03 Berlin"
      ],
      "ordered": false
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Entscheidung am Nachmittag"
    },
    {
      "type": "paragraph",
      "content": "Die Platzierungsspiele um die Plätze sieben und fünf werden auf dem Nebenplatz bei Hannover 78 ausgetragen. Das Spiel um Platz sieben beginnt um 15.14 Uhr, das Spiel um Platz fünf um 15.36 Uhr."
    },
    {
      "type": "paragraph",
      "content": "Zeitgleich geht es auf dem Hauptplatz im Erika Fisch Stadion um den Einzug in das Finale. Die beiden Halbfinals beginnen um 15.14 Uhr und um 15.36 Uhr."
    },
    {
      "type": "paragraph",
      "content": "Um 17.00 Uhr folgt der Höhepunkt des Männerturniers: Im Finale wird der Deutsche Meister 2026 ermittelt. Das Spiel um Platz drei bildet um 17.52 Uhr den sportlichen Abschluss des Turniertages."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Livestream und TV Übertragung"
    },
    {
      "type": "paragraph",
      "content": "Auch von zu Hause aus können Rugbyfans das Männerturnier verfolgen. Die Spiele auf dem Nebenplatz werden mit einer Veo Kamera produziert und im offiziellen YouTube Kanal von Rugby Deutschland live übertragen."
    },
    {
      "type": "paragraph",
      "content": "Die drei Gruppenspiele auf dem Hauptplatz werden im Rahmen der TV Produktion produziert. Auch diese Begegnungen sind im YouTube Livestream von Rugby Deutschland zu sehen."
    },
    {
      "type": "paragraph",
      "content": "Die Halbfinals, das Spiel um Platz drei und das Finale werden außerdem im Livestreamangebot von ARD und ZDF übertragen. Für die Halbfinals ist bereits ein eigener ZDF Livestream angekündigt. Auch das Finale und das Spiel um Platz drei werden in einem gemeinsamen Livestream gezeigt. Das Finale wird zusätzlich im Fernsehen beim ZDF zu sehen sein."
    },
    {
      "type": "paragraph",
      "content": "Neun Mannschaften, zwei Spielstätten und ein kompakter Turniertag: In Hannover ist alles für eine spannende Deutsche Meisterschaft im 7er Rugby der Männer angerichtet."
    }
  ]
};
